module.exports = __webpack_public_path__ + "static/media/activity-board.f26e52ba.svg";